// Rows come from the authenticated tenant's product API, not the filtered grid.
export const withProductOptions = (columns, rows) => columns.map(column => {
  if (!['singleSelect', 'multipleSelects'].includes(column.type)) return column;
  const values = rows.flatMap(row => {
    const value = row[column.field];
    return column.type === 'multipleSelects' ? (Array.isArray(value) ? value : []) : [value];
  }).filter(value => typeof value === 'string').map(value => value.trim()).filter(Boolean);
  const names = [...new Set(values)].sort();
  return { ...column, options: names.map(name => ({ id: name, name })), valueOptions: names };
});
